/**
 * routes/Login — the token gate. Enter the dashboard token; on success the SPA stores
 * the session and the router redirects to the Overview. Mirrors the backend login
 * (same opaque token), but the SPA verifies it via the JSON API rather than a form POST.
 */
import { useState } from 'react';

import { useAuth } from '../auth/AuthProvider';

export function Login(): JSX.Element {
  const { login } = useAuth();
  const [token, setToken] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(token);
      // AuthProvider flips `authed`; the router swaps this screen for the shell.
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login">
      <form className="login__card" onSubmit={onSubmit}>
        <div className="login__brand">
          <span className="topbar__logo">TK</span>
          <span>Trade Kharvyn</span>
        </div>
        <p className="login__sub">
          Committee trading terminal · <span className="secondary">demo</span>. Sign in with your
          dashboard token.
        </p>

        <div className="field">
          <label htmlFor="token">Dashboard token</label>
          <input
            id="token"
            className="input"
            type="password"
            autoComplete="current-password"
            placeholder="••••••••••••••••"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            autoFocus
          />
        </div>

        {error && (
          <div className="banner-error" role="alert" style={{ marginBottom: 'var(--sp-4)' }}>
            {error}
          </div>
        )}

        <button className="btn btn--primary" type="submit" style={{ width: '100%' }} disabled={busy}>
          {busy ? 'Verifying…' : 'Sign in'}
        </button>
      </form>
    </main>
  );
}
